<template>
  <div v-if="isMountedRef" class="container pt-5">
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-4 justify-items-center mt-5"
    >
      <div class="text-center md:pt-[100px]">
        <h1 class="font-bold mb-5">{{ t("error.404_title") }}</h1>
        <p>{{ t("error.404_description") }}</p>
      </div>
      <div class="px-4 md:px-0">
        <img
          src="/images/404.png"
          class="my-5 max-w-full lg:max-w-[540px] w-full"
          alt="404"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
const isMountedRef = ref(false);

const { t } = useI18n();

onMounted(() => {
  isMountedRef.value = true;
});
</script>
